import { render, staticRenderFns } from "./question_sfc_procedure.vue?vue&type=template&id=205e4ac4&scoped=true"
import script from "./question_sfc_procedure.vue?vue&type=script&lang=js"
export * from "./question_sfc_procedure.vue?vue&type=script&lang=js"
import style0 from "./question_sfc_procedure.vue?vue&type=style&index=0&id=205e4ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e4ac4",
  null
  
)

export default component.exports